(() => {
	const ingredients = qsa('.js-recipe__ingredients-item');
	const minus = qs('.js-recipe__num-people-button-minus');
	const plus = qs('.js-recipe__num-people-button-plus');
	const quantity = qs('.js-recipe__num-people-quantity');
	const ingredientsData = localStorage.getItem('ingredients'); 
	let newQuantity = 0;
	if (quantity) {
		newQuantity = quantity.innerText;
	}
	let numbersArr = [];
	let newNumbersArr = [];

	// Get the ingredients data and match with number
	if(ingredients) { 
		ingredients.forEach(el => {
			const number = qs('span', el);
			const numbers = number.innerHTML.match(/\d+/g);
			numbersArr.push(numbers);
		});
	}

	setTimeout(() => {
		numbersArr && numbersArr.forEach(num => {
      if (!num) {
        return;
      }

			if(num.length === 1) {
				newNumbersArr.push(parseInt(num) / 2);
			} else {
				let frac = '';
				num.forEach((el, i) => {
					if(i > 0) {
						frac += `/${el}`;
					} else {
						frac += `${el}`;
					}
				});
				
				newNumbersArr.push(convertStringToFraction(frac) / 2);
			}
		});
	});

	setTimeout(() => {
		if(newNumbersArr) {
			localStorage.setItem('ingredients', newNumbersArr);
		}
	}, 50);

	if(plus) {
		plus.addEventListener('click', (e) => {
			e.preventDefault();
			const currentQuantity = parseInt(quantity.innerText);
			newQuantity = currentQuantity + 1;

			if(newQuantity > 0) {
				plusAndMinus(newQuantity);
			};
		})
	}

	if(minus) {
		minus.addEventListener('click', (e) => {
			e.preventDefault();
			const currentQuantity = parseInt(quantity.innerText);
			newQuantity = currentQuantity - 1;
		
			if(newQuantity > 0) {
				plusAndMinus(newQuantity);
			};
		})
	}

	function plusAndMinus(num) {
		const data = ingredientsData.split(',');
		let itemValue = '';
		data && data.forEach((el, index) => {
			if(el.indexOf('.') > -1) {
				const product = el * num;
				if(product.toString().indexOf('.') > -1) {
					const decimal = `.${product.toFixed(2).split('.')[1]}`;
					const floor = Math.floor(product);
					if(floor === 0) {
						itemValue = `${decimalToFraction(decimal)}`;
					} else {
						itemValue = `${Math.floor(product)} ${decimalToFraction(decimal)}`;
					}
				} else {
					itemValue = product;
				}
			} else {
				itemValue = el * num;
			}

			if(ingredients) {
				ingredients.forEach((item, i) => {
					if(index === i) {
						qs('span', item).innerText = itemValue;
					}
				})
			}
		});

		quantity.innerText = num;
	}

	function convertStringToFraction(str) {
		const parts = str.split('/');
	
		if (parts.length === 2) {
			const numerator = parseInt(parts[0]);
			const denominator = parseInt(parts[1]);
	
			if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
				return numerator / denominator;
			}
		}
	
		return null; // Return null if the string is not a valid fraction
	}

	function decimalToFraction(decimal) {
		// Calculate the GCD
		function gcd(a, b) {
			return b ? gcd(b, a % b) : a;
		}
	
		// Convert decimal to fraction
		let numerator = decimal * 100;
		let denominator = 100;
		const divisor = gcd(numerator, denominator);
		numerator /= divisor;
		denominator /= divisor;
	
		// Format the fraction as a string
		const fraction = numerator + '/' + denominator;
		return fraction;
	}
})();
